/* eslint-disable react-hooks/exhaustive-deps */
import {
  GoogleMap,
  Marker,
  Polyline,
  useJsApiLoader,
} from "@react-google-maps/api";
import React, { memo, useCallback, useEffect, useState } from "react";
import { getLocalStorageWithExpiry } from "../../locales/langFunc";
import getCountry from "../../library/getCountry";
import LogMultiProgress from "./LogMultiProgress";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  deviceCenterAtom,
  deviceCheckedArrAtom,
  deviceCntTimestampAtom,
  deviceColorArrAtom,
} from "../../recoil/device";

const containerStyle = {
  width: "100%",
  height: "650px",
};

const getColorByNumber = (index) => {
  switch (index) {
    case 0:
      return "#FF0000";
    case 1:
      return "#00FF00";
    case 2:
      return "#0000FF";
    case 3:
      return "#FFFF00";
    case 4:
      return "#FF00FF";
    case 5:
      return "#00FFFF";
    case 6:
      return "#800080";
    case 7:
      return "#808080";
    case 8:
      return "#FFFFFF";
    case 9:
      return "#000000";
    default:
      return "#000000";
  }
};

// 브라우저에 설정된 언어 국가 가져오기
const lang = getLocalStorageWithExpiry("i18nextLng") || getCountry();

// 컴포넌트 선언
const LogMultiMap = ({ deviceMap, startTimestamp, endTimestamp }) => {
  const [center, setCenter] = useState({ lat: 0, lng: 0 });
  /* const [loadedDeviceMap, setLoadedDeviceMap] = useState(new Map()); */
  const [cntTimestamp, setCntTimestamp] = useRecoilState(
    deviceCntTimestampAtom
  );
  const [colors, setColors] = useRecoilState(deviceColorArrAtom);
  const checkedDevices = useRecoilValue(deviceCheckedArrAtom);
  const deviceCenter = useRecoilValue(deviceCenterAtom);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyB9QJIjB0qhLHWbR68rQw6-JyEtKZG9aqo",
    language: lang,
  });

  // 값이 있는 Serial의 path.lat/lng을 초기 Camera center로 지정
  useEffect(() => {
    for (const [serial, path] of deviceMap.entries()) {
      if (path.selectedPath[0] !== null && path.selectedPath[0] !== undefined) {
        setCenter({
          lat: parseFloat(path.selectedPath[0]?.lat || path.prevTimestamp?.lat || 0),
          lng: parseFloat(path.selectedPath[0]?.lng || path.prevTimestamp?.lng || 0),
        });
        break;
      }
    }
    const initialColors = {};
    for (const [index, serial] of Array.from(deviceMap.keys()).entries()) {
      initialColors[serial] = getColorByNumber(index);
    }
    setCntTimestamp(startTimestamp);
    setColors(initialColors);
  }, [deviceMap]);

  // 로그 테이블에서 device Active시에, 해당 device의 현재 위/경도값으로 구글 API Center값 설정
  useEffect(() => {
    if (deviceCenter) {
      setCenter({
        lat: parseFloat(
          deviceMap.get(deviceCenter)?.searchLog[cntTimestamp]?.lat ||
            deviceMap.get(deviceCenter)?.searchLog[
              deviceMap.get(deviceCenter)?.prevTimestamp
            ]?.lat || 0
        ),
        lng: parseFloat(
          deviceMap.get(deviceCenter)?.searchLog[cntTimestamp]?.lng ||
            deviceMap.get(deviceCenter)?.searchLog[
              deviceMap.get(deviceCenter)?.prevTimestamp
            ]?.lng || 0
        ),
      });
    }
  }, [cntTimestamp]);

  const updateFunc = useCallback((value) => {
    setCntTimestamp(value);
  }, []);

  return (
    <div>
      {isLoaded && (
        <section>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={18}
          >
            {Array.from(deviceMap.entries())
              .sort(([, pathA], [, pathB]) => {
                // Start Date 순서로 Sorting
                const dateA = pathA.selectedPath[0]?.date;
                const dateB = pathB.selectedPath[0]?.date;
                if (dateA && dateB) {
                  return new Date(dateA) - new Date(dateB);
                } else {
                  return 0;
                }
              })
              .map(([serial, path], index) => (
                <div key={serial}>
                  {/* Path line - line */}
                  {checkedDevices[serial] === true &&
                  path.selectedPath.length > 0 ? (
                    <Polyline
                      key={serial + "-dots-" + index}
                      options={{
                        strokeColor: colors[serial],
                        strokeOpacity: deviceCenter
                          ? deviceCenter === serial
                            ? 1
                            : 0.2
                          : 1,
                        strokeWeight: 1.5,
                        zIndex: 9,
                        clickable: false,
                        optimized: true,
                      }}
                      path={path.selectedPath}
                    />
                  ) : (
                    <></>
                  )}
                  {/* Path line - dot  */}
                  {/* {checkedDevices[serial] === true &&
                  path.selectedPath.length > 0 ? (
                    <>
                      {path.selectedPath.map((point, index) => (
                        <Marker
                          key={index}
                          icon={{
                            url: Dot,
                            scaledSize: new window.google.maps.Size(5, 5),
                          }}
                          position={{
                            lat: point.lat,
                            lng: point.lng,
                          }}
                        />
                      ))}
                    </>
                  ) : (
                    <></>
                  )} */}
                  {/* Start Marker */}
                  {checkedDevices[serial] === true &&
                  path.selectedPath.length > 0 ? (
                    <Marker
                      key={serial + "-start-" + index}
                      icon={{
                        path: faFlag.icon[4],
                        fillColor: "blue",
                        fillOpacity: deviceCenter
                          ? deviceCenter === serial
                            ? 0.75
                            : 0.1
                          : 0.75,
                        anchor: new window.google.maps.Point(
                          faFlag.icon[0] / 2,
                          faFlag.icon[1]
                        ),
                        strokeWeight: 1,
                        strokeColor: "#ffffff",
                        scale: 0.075,
                      }}
                      position={{
                        lat: parseFloat(path.selectedPath[0]?.lat),
                        lng: parseFloat(path.selectedPath[0]?.lng),
                      }}
                      label={{
                        text: `${index + 1}`,
                        fontSize: "20px",
                        color: "white",
                        className: "marker-class",
                      }}
                      title={serial}
                      zIndex={10}
                    />
                  ) : (
                    <></>
                  )}
                  {/* End Marker */}
                  {checkedDevices[serial] === true &&
                  path.selectedPath.length > 0 ? (
                    <Marker
                      key={serial + "-end-" + index}
                      icon={{
                        path: faFlag.icon[4],
                        fillColor: "#000",
                        fillOpacity: deviceCenter
                          ? deviceCenter === serial
                            ? 0.75
                            : 0.1
                          : 0.75,
                        anchor: new window.google.maps.Point(
                          faFlag.icon[0] / 2,
                          faFlag.icon[1]
                        ),
                        strokeWeight: 1,
                        strokeColor: "#ffffff",
                        scale: 0.075,
                      }}
                      position={{
                        lat: parseFloat(
                          path.selectedPath[path.selectedPath.length - 1]?.lat
                        ) || 0,
                        lng: parseFloat(
                          path.selectedPath[path.selectedPath.length - 1]?.lng
                        ) || 0,
                      }}
                      label={{
                        text: `${index + 1}`,
                        fontSize: "20px",
                        color: "white",
                        className: "marker-class",
                      }}
                      title={serial}
                      zIndex={10}
                    />
                  ) : (
                    <></>
                  )}
                  {/* Current Marker */}
                  {checkedDevices[serial] === true &&
                  path.selectedPath.length > 0 ? (
                    <Marker // Marker가 움직이는 것을 텍스트가 따라오는 데에 딜레이가 심하여 숫자가 적힌 이미지로 적용
                      // icon={{
                      //   url: `/image/marker_${index + 1}.png` || MarkerIcon,
                      //   scaledSize: new window.google.maps.Size(35, 35),
                      // }}
                      position={{
                        lat: parseFloat(
                          path.searchLog[cntTimestamp]?.lat
                            ? path.searchLog[cntTimestamp]?.lat.toFixed(9)
                            : path.searchLog[path.prevTimestamp]?.lat
                            ? path.searchLog[path.prevTimestamp]?.lat.toFixed(9)
                            : 0
                        ),
                        lng: parseFloat(
                          path.searchLog[cntTimestamp]?.lng
                            ? path.searchLog[cntTimestamp]?.lng.toFixed(9)
                            : path.searchLog[path.prevTimestamp]?.lng
                            ? path.searchLog[path.prevTimestamp]?.lng.toFixed(9)
                            : 0
                        ),
                      }}
                      opacity={1.0}
                      label={{
                        text: `${index + 1}`,
                        fontSize: "20px",
                        color: "white",
                      }}
                      title={serial}
                      zIndex={11}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            <LogMultiProgress
              startTimestamp={startTimestamp}
              endTimestamp={endTimestamp}
              updateFunc={updateFunc}
            />
          </GoogleMap>
        </section>
      )}
    </div>
  );
};

export default memo(LogMultiMap);
